
import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-table components
import { useTable, usePagination, useGlobalFilter, useAsyncDebounce,  useFilters,
  useSortBy } from "react-table";
import AddSharp from '@mui/icons-material/AddSharp';
// @mui material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Icon from "@mui/material/Icon";
import ReactTooltip from 'react-tooltip';

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiPagination from "components/SuiPagination";
import SuiButton from "components/SuiButton";
import NativeSelect from '@mui/material/NativeSelect';

// Soft UI Dashboard PRO React example components
import DataTableHeadCell from "./DataTableHeadCell";
import DataTableBodyCell from "./DataTableBodyCell";import { whitespace } from "stylis";

function DataTable({
  entriesPerPage,
  canSearch,
  showTotalEntries,
  table,ageOutside,
  LoadData=true,
  pagination,
  isSorted,
  noEndBorder,
  datacolumns,
  datalength,
  hidecolumnsdata,
  functioncallcount
}) {
  const defaultValue = entriesPerPage.defaultValue ? entriesPerPage.defaultValue : 10;
  const entries = entriesPerPage.entries ? entriesPerPage.entries : [ 10, 15, 20, 25];
  const columns = useMemo(() => datacolumns, [datacolumns]);
  const data = useMemo(() => table, [table]);

  const tableInstance = useTable(
    { columns, data, initialState: { pageIndex: 0,hiddenColumns:hidecolumnsdata, },autoResetHiddenColumns:false },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );

  const hidecolumns = (value) => {
    if (hidecolumnsdata && hidecolumnsdata.length !== 0) {
      hidecolumnsdata.map((head) => {
        toggleHideColumn(head, value);
      });
    }
  };
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    page,
    pageOptions,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    setFilter,
    toggleHideColumn,
    state: { pageIndex, pageSize, globalFilter },
  } = tableInstance;

  // Set the default value for the entries per page when component mounts
  useEffect(() => setPageSize(defaultValue || 10), [defaultValue]);
  useEffect(() => {
    if(ageOutside!==undefined){
    setFilter("city", ageOutside);
    }
  }, [ageOutside]);
  // Set the entries per page value based on the select value
  const setEntriesPerPage = ({ value }) => setPageSize(value);

  // Render the paginations
  const renderPagination = pageOptions.map((option) => (
    <SuiPagination
      item
      key={option}
      onClick={() => gotoPage(Number(option))}
      active={pageIndex === option}
    >
      {option + 1}
    </SuiPagination>
  ));

  // Handler for the input to set the pagination index
  const handleInputPagination = ({ target: { value } }) =>
    value > pageOptions.length || value < 0 ? gotoPage(0) : gotoPage(Number(value));

  // Customized page options starting from 1
  const customizedPageOptions = pageOptions.map((option) => option + 1);

  // Setting value for the pagination input
  const handleInputPaginationValue = ({ target: value }) => gotoPage(Number(value.value - 1));

  // Search input value state
  const [search, setSearch] = useState(globalFilter);

  // Search input state handle
  const onSearchChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  // A function that sets the sorted value for the table
  const setSortedValue = (column) => {
    let sortedValue;

    if (isSorted && column.isSorted) {
      sortedValue = column.isSortedDesc ? "desc" : "asce";
    } else if (isSorted) {
      sortedValue = "none";
    } else {
      sortedValue = false;
    }

    return sortedValue;
  };

  // Setting the entries starting point
  const entriesStart = pageIndex === 0 ? pageIndex + 1 : pageIndex * pageSize + 1;

  // Setting the entries ending point
  let entriesEnd;

  if (pageIndex === 0) {
    entriesEnd = pageSize;
  } else if (pageIndex === pageOptions.length - 1) {
    entriesEnd = rows.length;
  } else {
    entriesEnd = pageSize * (pageIndex + 1);
  }

  return (
    <TableContainer sx={{ boxShadow: "none" }}>
      {entriesPerPage || canSearch ? (
        <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
          {hidecolumnsdata.length !== 0 ? <>
            <SuiButton
              sx={{ width: '7rem', padding: '5px', marginRight: '5px' }}
              variant="gradient" onClick={() => {
                hidecolumns(false);
              }} color="info" fullWidth>
              Show more
            </SuiButton>
            <SuiButton
              sx={{ width: '7rem', padding: '5px', marginRight: '5px' }}
              variant="gradient" onClick={() => {
                hidecolumns(true);
              }} color="info" fullWidth>
              show less
            </SuiButton>
          </> : null}
          {LoadData?(<SuiSelect
            size='small'
            widths={'20vw'}
            defaultValue={{ value: 0, label: 'Add Records' }}
            options={[0, 10, 100, 500, 1000,2000].map((entry) => ({ value: entry, label: entry }))}
            onChange={(e) => functioncallcount(e.value)}
            placeholder="Select row`s to add"
          />):null}
          {canSearch && (
            <SuiBox width="12rem" ml="auto">
              <SuiInput
                placeholder="Search..."
                value={search}
                onChange={({ currentTarget }) => {
                  setSearch(search);
                  onSearchChange(currentTarget.value);
                }}
              />
            </SuiBox>
          )}


        </SuiBox>
      ) : null}
      <Table {...getTableProps()}>
        <SuiBox component="thead">
          {headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <DataTableHeadCell
                  sx={{
                    textTransform: 'capitalize',
                    maxWidth: column.width ? column.width : "auto",

                  }}
                  {...column.getHeaderProps(isSorted && column.getSortByToggleProps())}
                  align={column.align ? column.align : "left"}
                  sorted={setSortedValue(column)}
                >
                  {column.render("Header")}
                </DataTableHeadCell>
              ))}
            </TableRow>
          ))}
        </SuiBox>
        <TableBody {...getTableBodyProps()}>
          {page.map((row, key) => {
            prepareRow(row);
            return (
              <TableRow {...row.getRowProps()}>
                {row.cells.map((cell, key) => (
                  <DataTableBodyCell
                    noBorder={noEndBorder && rows.length - 1 === key}
                    align={cell.column.align ? cell.column.align : "left"}

                    {...cell.getCellProps()}
                  >
                    {cell.column.tooltip ? (<><p
                      data-tip={cell.value}
                      style={{
                        maxWidth: cell.column.width ? cell.column.width : "auto",
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}>
                      {cell.render("Cell")}
                    </p>

                      <ReactTooltip place="top" type="dark" effect="solid" /></>)
                      : (<p
                        style={{
                          maxWidth: cell.column.width ? cell.column.width : "auto",
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}>
                        {cell.render("Cell")}
                      </p>
                      )}



                  </DataTableBodyCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      <SuiBox
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        p={!showTotalEntries && pageOptions.length === 1 ? 2 : 3}
      >
        {showTotalEntries && (
          <SuiBox mb={{ xs: 3, sm: 0 }}>
            <SuiTypography variant="button" color="secondary" fontWeight="regular">
              Showing {entriesStart} to {rows.length<entriesEnd?rows.length:entriesEnd} of {datalength || rows.length} entries
            </SuiTypography>
          </SuiBox>
        )}
        {!showTotalEntries && (
          <SuiBox mb={{ xs: 3, sm: 0 }}>
                      <SuiTypography variant="button" color="secondary" fontWeight="regular">
                      </SuiTypography>
          </SuiBox>
        )}
        <SuiBox mb={{ xs: 3, sm: 0 }} >
          <SuiTypography variant="caption" color="secondary">
            &nbsp;&nbsp;entries per page
            <select

              onChange={(e) => { setEntriesPerPage({ value: Number(e.target.value), label: e.target.value }) }}
              style={{ border: 0, textDecoration: 'none', color: 'inherit', outline: 'none' }} >
              {
                entriesPerPage.entries.map((d, key) => (<option key={key} value={d}>{d}</option>))
              }


            </select>
          </SuiTypography>

        </SuiBox>

        {pageOptions.length > 1 && (
          <SuiPagination
            variant={pagination.variant ? pagination.variant : "gradient"}
            color={pagination.color ? pagination.color : "info"}
          >
            {canPreviousPage && (
              <SuiPagination item onClick={() => previousPage()}>
                <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
              </SuiPagination>
            )}
            {renderPagination.length > 6 ? (
              <SuiBox width="5rem" mx={1}>
                <SuiInput
                  inputProps={{ type: "number", min: 1, max: customizedPageOptions.length }}
                  value={customizedPageOptions[pageIndex]}
                  onChange={(handleInputPagination, handleInputPaginationValue)}
                />
              </SuiBox>
            ) : (
              renderPagination
            )}
            {canNextPage && (
              <SuiPagination item onClick={() => nextPage()}>
                <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
              </SuiPagination>
            )}
          </SuiPagination>
        )}
      </SuiBox>
    </TableContainer>
  );
}

// Setting default values for the props of DataTable
DataTable.defaultProps = {
  entriesPerPage: { defaultValue: 10, entries: [ 10, , 20, 50] },
  canSearch: false,
  showTotalEntries: false,
  pagination: { variant: "gradient", color: "success" },
  isSorted: true,
  noEndBorder: false,
};

// Typechecking props for the DataTable
DataTable.propTypes = {
  entriesPerPage: PropTypes.oneOfType([
    PropTypes.shape({
      defaultValue: PropTypes.number,
      entries: PropTypes.arrayOf(PropTypes.number),
    }),
    PropTypes.bool,
  ]),
  canSearch: PropTypes.bool,
  showTotalEntries: PropTypes.bool,
  table: PropTypes.objectOf(PropTypes.array).isRequired,
  pagination: PropTypes.shape({
    variant: PropTypes.oneOf(["contained", "gradient"]),
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
    ]),
  }),
  isSorted: PropTypes.bool,
  noEndBorder: PropTypes.bool,
};

export default DataTable;
